import { format } from 'date-fns';
import { toDate } from 'date-fns-tz';
import { es } from 'date-fns/locale';
import { DateRange } from 'react-day-picker';

import { capitalize } from '../../../utils/capitalize';
import { FORMAT } from '../../../utils/format-date-time';

import { SYSTEM_TIMEZONE } from './time-zone';

const DATE_FORMAT = 'dd MMMM yyyy';
const DATE_FORMAT_TIME = FORMAT.dd_MMMM_YYYY_HH_mm;
const PLACEHOLDER = 'Fecha';

interface GetFormattedDateProps {
  date: Date | DateRange | undefined;
  hasTime?: boolean;
  timeZone?: string;
}

export function getFormattedDate({
  date,
  hasTime = false,
  timeZone = SYSTEM_TIMEZONE,
}: GetFormattedDateProps): string {
  if (!date) return PLACEHOLDER;
  const FORMAT = hasTime ? DATE_FORMAT_TIME : DATE_FORMAT;

  if ('from' in date) {
    const from = date?.from
      ? capitalize(format(toDate(date.from, { timeZone }), FORMAT, { locale: es }))
      : '';

    const to = date?.to
      ? capitalize(format(toDate(date.to, { timeZone }), FORMAT, { locale: es }))
      : '';

    return from && to ? `${from} - ${to}` : from || PLACEHOLDER;
  }

  return capitalize(format(toDate(date, { timeZone }), FORMAT, { locale: es }));
}
